// @ vendor
import React, { useEffect } from 'react';

// @ components
import { LoadingSection } from 'commonsComponents/loadingSection';

// @ constants
import {
  IDENTIFICATION_QUERY_RESULT,
  LOADER_WIDTH,
  MIGRATION_STATE,
} from '../../migrationUsersBranchView.constants';

export const IdentificationCompletionHandler = ({ result, handleChangeMigrationState }) => {
  useEffect(() => {
    handleChangeMigrationState(
      result === IDENTIFICATION_QUERY_RESULT.SUCCESS
        ? MIGRATION_STATE.MIGRATION_SUCCESS
        : MIGRATION_STATE.MIGRATION_KO
    );
  }, []);

  return (
    <div className="app__spinner">
      <LoadingSection type="round" width={LOADER_WIDTH} />
    </div>
  );
};
